import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getVisitSearch = get('guest.components.visitSearch');

export const getGuestVisitSearchQuery = createSelector(
  getVisitSearch,
  get('query')
);
